
const data = [
  {
    title: '知识转移与培训概述',
    description: '知识转移与培训是转移信息技术知识、经营管理知识、融合技术与管理的系统知识，以及专业业务知识等的过程。是企业信息化部署、改革和升级转型的重要环节，完备的知识转移和培训可提高企业应对新环境、新系统、新模式的应变能力，降低风险，缩减成本，提升效率。'
  },
  {
    title: '服务内容',
    description: '制定知识转移与培训的策略\n' +
      '明确知识形态与知识转移培训\n' +
      '知识转移与企业自主创新培训'
  },
  {
    title: '服务特点',
    description: '提供多种知识转移与培训的方式，主要有：合同型、指导型、参照型、适应型等。\n' +
      '知识转移与培训分两大阶段：共享和吸收。共享可通过面对面教授、远程授课、电子邮件、文件文档、查看知识库等方式完成；吸收可通过现场提问、考试、实际操作等方式进行验证。'
  }
];

export default data;


// WEBPACK FOOTER //
// ./src/routes/Service/config/train-knowledge.js